export enum CompanyOverrideStatus {
  Set = "Set",
  NotSet = "Not set"
}
